/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 项目入口文件
 * @Date: 2021-09-09 10:40:15
 * @LastEditTime: 2022-03-21 10:58:22
 */
import '@babel/polyfill'//ES6+ 方法转ES5
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import Router from 'src/routes/'
//重置浏览器默认样式
import 'reset-xiaoxi'

import 'antd/dist/antd.css';

// //全局布局文件
import 'layout-xiaoxi'
//antdesign 重置
import "assets/css/ant.reset.css"
//其他全局文件
import 'assets/css/public.less';
//适配文件
import 'assets/css/media.less';
// 应用入口
import App from 'views/app'

//应用状态管理文件
import store from "src/store"

// //全局ajax工具
import { post, get } from 'utils/request';

//全局配置文件
import api from 'config/api.config'
import regexp from 'config/regexp.config'

//挂载全局方法
React.$post = post
React.$get = get
//api配置文件
React.$api = api
//正则配置文件
React.$regexp = regexp
//挂载
render(
  <React.StrictMode>
    <Provider store={store}>
      <ReactRouter.BrowserRouter>
        <App><Router />  </App>
      </ReactRouter.BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
